import type { ComponentType } from 'react';
import type { FieldType } from '@/api/modules/metadata';
import { TextInput } from './fields/TextInput';
import { NumberInput } from './fields/NumberInput';
import { SelectInput } from './fields/SelectInput';
import { DateInput } from './fields/DateInput';
import { CheckboxInput } from './fields/CheckboxInput';
import type { FieldRendererProps, FieldDefinition } from './types';

/**
 * Field-type → component lookup. Adding a new {@link FieldType} on the backend
 * means: (a) extend the union in {@code api/modules/metadata.ts}, (b) build a
 * renderer component, (c) register it here. The {@link DynamicForm} consumes
 * this map only — no other UI code touches FieldType.
 */
export const fieldRegistry: Record<
  FieldType,
  ComponentType<FieldRendererProps & { definition: FieldDefinition }>
> = {
  TEXT: TextInput,
  NUMBER: NumberInput,
  ENUM: SelectInput,
  DATE: DateInput,
  BOOLEAN: CheckboxInput
};
